import { PageContainer } from '@toolpad/core/PageContainer';
import BillingManagementPanel from '../components/Admin/BillingManagementPanel';

const BillingPage = () => {
  return (
    <PageContainer title="Billing">
      <BillingManagementPanel />
    </PageContainer>
  );
};

export default BillingPage;
